var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var omit = function (obj, keys) {
    return Object.entries(obj)
        .filter(function (_a) {
        var key = _a[0];
        return !keys.includes(key);
    })
        .reduce(function (objCtx, _a) {
        var _b;
        var key = _a[0], val = _a[1];
        return Object.assign(objCtx, (_b = {}, _b[key] = val, _b));
    }, {});
};
export var pick = function (obj, keys) {
    return Object.entries(obj)
        .filter(function (_a) {
        var key = _a[0];
        return keys.includes(key);
    })
        .reduce(function (objCtx, _a) {
        var _b;
        var key = _a[0], val = _a[1];
        return Object.assign(objCtx, (_b = {}, _b[key] = val, _b));
    }, {});
};
export var mapValues = function (obj, iteratee) {
    return Object.entries(obj).reduce(function (acc, _a) {
        var _b;
        var key = _a[0], value = _a[1];
        return (__assign(__assign({}, acc), (_b = {}, _b[key] = iteratee(value, key, obj), _b)));
    }, {});
};
export var isFunction = function (value) {
    return value &&
        ['[object Function]', '[object AsyncFunction]'].includes({}.toString.call(value));
};
export var isString = function (value) {
    return (value || value === '') &&
        Object.prototype.toString.call(value) === '[object String]';
};
export var isObject = function (value) {
    return typeof value === 'object';
};
export var isNil = function (value) { return value == null; };
export var has = function (value, key) {
    return isObject(value) && !isNil(value) && value.hasOwnProperty(key);
};
export var clamp = function (value, min, max) {
    var temp = value;
    if (temp < min) {
        temp = min;
    }
    if (temp > max) {
        temp = max;
    }
    return temp;
};
var extremumBy = function (values, iteratee, extremum) {
    var bestPair = values.reduce(function (best, next) {
        var pair = [iteratee(next), next];
        if (!best) {
            return pair;
        }
        else if (extremum.apply(null, [best[0], pair[0]]) === best[0]) {
            return best;
        }
        else {
            return pair;
        }
    }, null);
    if (!bestPair) {
        return null;
    }
    return bestPair[1];
};
export var minBy = function (values, iteratee) { return extremumBy(values, iteratee, Math.min); };
export var maxBy = function (values, iteratee) { return extremumBy(values, iteratee, Math.max); };
export var throttle = function (callback, wait, immediate) {
    if (immediate === void 0) { immediate = false; }
    var timeout;
    var initialCall = true;
    var wrappedCallback = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var callNow = immediate && initialCall;
        var next = function () {
            callback.apply(void 0, args);
            timeout = undefined;
        };
        if (callNow) {
            initialCall = false;
            next();
        }
        if (timeout === undefined) {
            timeout = window.setTimeout(next, wait);
        }
    };
    return wrappedCallback;
};
//# sourceMappingURL=data.js.map